import React, { useEffect, useRef, useState } from "react";
import { Users, CheckCircle, School, Award } from "lucide-react";
import { stats } from "../mock";

const iconMap = {
  users: Users,
  "check-circle": CheckCircle,
  school: School,
  award: Award
};

const useCounter = (target, start) => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!start) return;
    const duration = 1800;
    const stepTime = 16;
    const steps = duration / stepTime;
    const inc = target / steps;
    let cur = 0;
    const id = setInterval(() => {
      cur += inc;
      if (cur >= target) {
        setVal(target);
        clearInterval(id);
      } else {
        setVal(Math.floor(cur));
      }
    }, stepTime);
    return () => clearInterval(id);
  }, [target, start]);
  return val;
};

const StatItem = ({ stat, start }) => {
  const Icon = iconMap[stat.icon] || Users;
  const value = useCounter(stat.value, start);
  return (
    <div className="flex items-center gap-5">
      <div className="w-16 h-16 rounded-full bg-green-50 border border-green-100 flex items-center justify-center text-green-600 flex-shrink-0">
        <Icon size={28} strokeWidth={1.8} />
      </div>
      <div>
        <div className="flex items-start">
          <span className="text-4xl md:text-5xl font-black text-[#0a2463] tabular-nums">{value.toLocaleString()}</span>
          <span className="text-2xl font-bold text-green-600 ml-0.5">+</span>
        </div>
        <p className="text-slate-600 font-medium mt-1">{stat.label}</p>
      </div>
    </div>
  );
};

const Stats = () => {
  const [start, setStart] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setStart(true);
        });
      },
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-14 bg-white border-t border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {stats.map((s) => (
          <StatItem key={s.id} stat={s} start={start} />
        ))}
      </div>
    </section>
  );
};

export default Stats;
